

























import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import EVMTransactions from '@/components/Transaction/EVMTransactions.vue'

@Component({
    components: {
        Loader,
        EVMTransactions,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMTransactionsPage extends Mixins(
    TransactionsGettersMixin
) {
    startingTx = 0
    transactionsOffsets = [10, 25, 50]
    transactionsOffset = this.transactionsOffsets[0]

    mounted() {
        this.updateTxs()
    }

    get latestBlock(): EVMBlockQueryResponse {
        return this.$root.$store.state.Blocks.evmBlock
    }

    get filteredTransactions(): ParsedEVMTx[] {
        return this.evmTransactions.slice(
            this.startingTx,
            this.startingTx + this.transactionsOffset
        )
    }

    @Watch('startingTx')
    controlStartingTx() {
        this.startingTx = Math.min(
            this.startingTx,
            this.evmTransactions.length - 1
        )
        this.startingTx = Math.max(this.startingTx, 0)
    }

    nextPage() {
        this.startingTx = this.startingTx + this.transactionsOffset
    }

    previousPage() {
        this.startingTx -= this.transactionsOffset
    }

    get evmTransactions(): ParsedEVMTx[] {
        return this.getEVMTxs()
    }
    updateOffset(offset: number) {
        this.transactionsOffset = offset
    }

    async updateTxs() {
        await this.$root.$store
            .dispatch('Transactions/getEVMTxs', {
                params: {
                    sort: 'timestamp-desc',
                },
            })
            .catch((err) => {
                console.log(err)
            })
    }
}
